module.exports = __webpack_public_path__ + "static/media/bitcoin2.f9c44cb8.png";